import Vue from 'vue'
import Vuex from 'vuex'

import apis from './modules/apis/'
import auth from './modules/auth'
import cash from './modules/cash'
import docRows from './modules/docRows'
import pwa from './modules/pwa'
import receipts from './modules/receipts'
import routes from './modules/routes'
import rules from './modules/rules'
import storage from './modules/storage'
import subscription from './modules/subscription'
import tenant from './modules/tenant'
import theme from './modules/theme'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

// export default function (/* { ssrContext } */) {
export default new Vuex.Store({
  modules: {
    apis,
    auth,
    cash,
    docRows,
    pwa,
    receipts,
    routes,
    rules,
    storage,
    subscription,
    tenant,
    theme,
  },

  // enable strict mode (adds overhead!)
  // for dev mode only
  // strict: process.env.DEV
})

// return Store
// }
